import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "./auth/AuthProvider";
import { Layout } from "./components/layout/Layout";
import { Dashboard } from "./pages/Dashboard";
import { AuditPage } from "./pages/Audit";
import { BusinessInfoPage } from "./pages/BusinessInfo";
import { DriveSyncPage } from "./pages/DriveSync";
import { IndustriesPage } from "./pages/Industries";
import { InputInvoicesPage } from "./pages/InputInvoices";
import { InvoiceThresholdPage } from "./pages/InvoiceThreshold";
import { Login } from "./pages/Login";
import { ManualRevenuePage } from "./pages/ManualRevenue";
import { PosOrdersPage } from "./pages/PosOrders";
import { ProductCodesPage } from "./pages/ProductCodes";
import { ProductGroupsPage } from "./pages/ProductGroups";
import { ProductPnlPage } from "./pages/ProductPnl";
import { ProductsPage } from "./pages/Products";
import { ReconciliationPage } from "./pages/Reconciliation";
import { SettlementsPage } from "./pages/Settlements";
import { ShopsPage } from "./pages/Shops";
import { SoS2aPage } from "./pages/SoS2a";
import { SuppliersPage } from "./pages/Suppliers";
import { UsersPage } from "./pages/Users";
import { VtpAccountsPage } from "./pages/VtpAccounts";

function Protected({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-gray-500">Đang tải...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="doanh-thu" element={<PosOrdersPage />} />
        <Route path="doanh-thu-thu-cong" element={<ManualRevenuePage />} />
        <Route path="doi-chieu" element={<ReconciliationPage />} />
        <Route path="bang-ke-vtp" element={<SettlementsPage />} />
        <Route path="hoa-don-dau-vao" element={<InputInvoicesPage />} />
        <Route path="dong-bo-drive" element={<DriveSyncPage />} />
        <Route path="nha-cung-cap" element={<SuppliersPage />} />
        <Route path="san-pham" element={<ProductsPage />} />
        <Route path="nhom-san-pham" element={<ProductGroupsPage />} />
        <Route path="ma-hang" element={<ProductCodesPage />} />
        <Route path="theo-doi-kinh-doanh" element={<ProductPnlPage />} />
        <Route
          path="lai-lo-sp"
          element={<ProductPnlPage />} />
        <Route path="so-s2a" element={<SoS2aPage />} />
        <Route path="nguong-hoa-don" element={<InvoiceThresholdPage />} />
        <Route path="kiem-tra-doanh-thu" element={<AuditPage />} />
        <Route path="thong-tin-kinh-doanh" element={<BusinessInfoPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="industries" element={<IndustriesPage />} />
        <Route path="shops" element={<ShopsPage />} />
        <Route path="tai-khoan-vtp" element={<VtpAccountsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
